import { BASE_URL } from 'config';
import { use, useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import usersTableData from "./data/usersTableData";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import AddUserModal from "../../components/AddUserModal";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { CircularProgress, Backdrop } from "@mui/material";
import RowsPerPageSelector from "components/RowsPerPageSelector";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Permissions from "layouts/role-permission/Permissions";

function Users() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState("all");
  const [isActive, setIsActive] = useState("all"); // "all", "1", "0"
  const [pageNumber, setPageNumber] = useState(1); // ← حالة لرقم الصفحة
  const [totalPages, setTotalPages] = useState(1); // ← حالة لإجمالي الصفحات
  const [permessionFormIsOpen, setPermessionFormIsOpen] = useState(false);
  const handleEditClick = (user) => {
    setCurrentUser(user);
    setModalOpen(true);
  };

  const handleEnvokePermissions = (user) => {
    setCurrentUser(user);
    setPermessionFormIsOpen(true); // ← فتح مودال الصلاحيات هنا
  };

  useEffect(() => {
    fetchUsers(pageNumber);
  }, [pageNumber]);

  const fetchUsers = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(
        `${BASE_URL}/administrator/users?page=${pageNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      console.log("🚀 ~ fetchUsers ~ data:", data);
      setUsers(data.data || []);
      setRowsPerPage(data.meta.per_page || 10);
      setTotalPages(data.meta.last_page || 1); // ← تحديث إجمالي الصفحات
      console.log("users", users);
      console.log("users , total pages", totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setLoading(false);
  };

  // search by name, email and status
  const fetchFilteredUsers = async (searchName, userType, status) => {
    setLoading(true);
    const token = localStorage.getItem("user-token");

    // بناء الرابط مع البرامترات
    const queryParams = new URLSearchParams({
      name: searchName || "",
      type: userType === "all" ? "" : userType,
      email: searchName || "",
      is_active: status === "all" ? "" : Number(status).toString(),
    });

    const url = `${BASE_URL}/administrator/users/filters?${queryParams.toString()}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      setUsers(data.data || []);
      setPage(0);
    } catch (error) {
      console.error("Error filtering users:", error);
    }

    setLoading(false);
  };

  const { columns, rows } = usersTableData(
    users,
    handleEditClick,
    handleEnvokePermissions,

    fetchUsers
  );

  const paginatedRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <AddUserModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentUser(null);
        }}
        onUserAdded={fetchUsers}
        initialData={currentUser}
      />
      <Permissions
        open={permessionFormIsOpen}
        onClose={() => {
          setPermessionFormIsOpen(false);
          setCurrentUser(null);
        }}
        user={currentUser}
      />

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة المستخدمين
            </MDTypography>

            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              مستخدم جديد
            </MDButton>
          </MDBox>

          <MDBox pt={3} px={2}>
            <MDBox display="flex" gap={2} mb={3}>
              <TextField
                label="بحث بالاسم أو البريد"
                variant="outlined"
                size="small"
                sx={{ flex: 1 }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    fetchFilteredUsers(search, type, isActive);
                  }
                }}
              />
              <FormControl size="small" sx={{ minWidth: 160 }}>
                <InputLabel id="user-status-label">الحالة</InputLabel>
                <Select
                  labelId="user-status-label"
                  value={isActive}
                  label="الحالة"
                  onChange={(e) => {
                    const status = e.target.value;
                    setIsActive(status);
                    fetchFilteredUsers(search, type, status); // ← تحديث البيانات بناءً على الحالة
                  }}
                  sx={{ height: "40px" }}
                >
                  <MenuItem value="all">الكل</MenuItem>
                  <MenuItem value="1">مفعل</MenuItem>
                  <MenuItem value="0">غير مفعل</MenuItem>
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ minWidth: 160 }}>
                <InputLabel id="user-type-label">النوع</InputLabel>
                <Select
                  labelId="user-type-label"
                  value={type}
                  label="النوع"
                  onChange={(e) => {
                    const newType = e.target.value;
                    setType(newType);
                    fetchFilteredUsers(search, newType, isActive);
                  }}
                  sx={{ height: "40px" }}
                >
                  <MenuItem value="all">الكل</MenuItem>
                  <MenuItem value="customer">عميل</MenuItem>
                  <MenuItem value="staff">موظف</MenuItem>
                  <MenuItem value="manager">مدير</MenuItem>
                  <MenuItem value="admin">مشرف</MenuItem>
                  <MenuItem value="administrator">مسؤول</MenuItem>
                </Select>
              </FormControl>
            </MDBox>

            <MDBox mb={2} display="flex">
              <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
            </MDBox>

            <DataTable
              table={{ columns, rows: paginatedRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={true}
              noEndBorder
              sx={{
                "& .MuiTable-root": { minWidth: 1000 },
                "& .MuiTableCell-root": {
                  py: 1.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                },
                "& .MuiTableHead-root": {
                  backgroundColor: (theme) => theme.palette.grey[100],
                },
              }}
            />


          </MDBox>
        </Card>
      </MDBox>
      <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
        <MDButton
          onClick={() => {
            if (pageNumber > 1) {
              setPageNumber(pageNumber - 1);
            }
          }}
          disabled={pageNumber === 1}
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            color: "text.main",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            minWidth: "50px",
            mx: 1,
            "&:hover": {
              background: "linear-gradient(90deg, #b6842f, #d39d45)",
            },
          }}
        >
          <ArrowForwardIcon />
        </MDButton>

        <MDTypography
          variant="button"
          color="text.main"
          sx={{
            display: "flex",
            alignItems: "center",
            mx: 3,
            fontWeight: "bold",
          }}
        >
          {pageNumber} / {totalPages}
        </MDTypography>

        <MDButton
          onClick={() => {
            if (pageNumber < totalPages) {
              setPageNumber(pageNumber + 1);
            }
          }}
          disabled={pageNumber === totalPages}
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            color: "text.main",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            minWidth: "50px",
            mx: 1,
            "&:hover": {
              background: "linear-gradient(90deg, #b6842f, #d39d45)",
            },
          }}
        >
          <ArrowBackIcon />
        </MDButton>
      </MDBox>
    </>
  );
}

export default Users;
